import { ref } from 'vue'

export function useBGColor() {
    const background = ref('#ffffff')
    const color = ref('#363636')

    const setBGColor = (input) => {
        if (!input) {
            background.value = '#ffffff'
            color.value = '#363636'
            return
        }

        let rgbaArray = input.startsWith('#') ? hexToRgbaArray(input) : parseRgbaString(input);

        if (!rgbaArray) {
            background.value = '#ffffff'
            color.value = '#363636'
            return
        }

        const [r, g, b, a] = rgbaArray
        background.value = `rgba(${r}, ${g}, ${b}, ${a})`
        color.value = getContrastColor(r, g, b, a)
    }

    return { background, color, setBGColor }
}

function hexToRgbaArray(hex) {
    hex = hex.replace(/^#/, '')
    if (hex.length === 3) hex = hex.split('').map(s => s + s).join('')

    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)
    return [r, g, b, 1]
}

function parseRgbaString(str) {
    const match = str.match(/\d+(\.\d+)?/g)
    return match ? match.map(Number) : null
}

export function getContrastColor(r, g, b, a = 1) {
    const toLinear = (v) => {
        const c = v / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };

    const L = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

    const threshold = 0.25;
    return L > threshold ? '#363636' : '#ffffff';
}
